let callbackId = 0;
let callbackMap = {};
let u = navigator.userAgent;
console.log(u);
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let isOhos = u.indexOf('ArkWeb') > -1;

export class WebJSBridge {
    static call(name, params, callback) {
        //生成callbackId
        let cbId = this.genCallbackId();
        //添加到callbackMap
        this.add(cbId, callback);

        //组装方法和参数
        let config = {name: name, params: params, callbackId: cbId};
        let string = JSON.stringify(config);
        console.log('params', params);
        if (name == 'closeWeb') {
            if (isAndroid) {
                android.closeWeb();
            } else {
                if (isOhos) {
                    window.ohosCallNative.callNative('closeWeb', {})
                }
                window.webkit.messageHandlers.closeWeb.postMessage(string);
            }
        } else if (name == 'openDynamicDesc') {
            if (isAndroid) {
                android.openDynamicDesc(params.ecgId, params.sportId, params.sportType, params.userAvatar, params.startSportTime);
            } else {
                window.webkit.messageHandlers.openDynamicDesc.postMessage(string);
            }
        } else if (name == 'openScanCode') {
            if (isAndroid) {
                android.openScanCode();
            } else {
                window.webkit.messageHandlers.openScanCode.postMessage(string);
            }
        } else if (name == 'openEcgList') {
            if (isAndroid) {
                android.openEcgList();
            } else {
                window.webkit.messageHandlers.openEcgList.postMessage(string);
            }
        } else if (name == 'shareReport') {
            if (isAndroid) {
                android.shareReport();
            } else {
                window.webkit.messageHandlers.shareReport.postMessage(string);
            }
        } else if (name == 'selectCity') {
            if (isAndroid) {
                android.selectCity(params.selectedCity);
            } else {
                window.webkit.messageHandlers.selectCity.postMessage(string);
            }
        } else if (name == 'updateWater') {
            if (isAndroid) {
                android.updateWater(params.waterCount);
            } else {
                window.webkit.messageHandlers.updateWater.postMessage(string);
            }
        } else if (name == 'updateWeight') {
            if (isAndroid) {
                android.updateWeight(params.weight);
            } else {
                window.webkit.messageHandlers.updateWeight.postMessage(string);
            }
        } else if (name == 'updateHeight') {
            if (isAndroid) {
                android.updateHeight(params.height);
            } else {
                window.webkit.messageHandlers.updateHeight.postMessage(string);
            }
        } else if (name == 'planEditSuccess') {
            if (isAndroid) {
                android.planEditSuccess();
            } else {
                window.webkit.messageHandlers.planEditSuccess.postMessage(string);
            }
        } else if (name == 'calendarEditSuccess') {
            if (isAndroid) {
                android.calendarEditSuccess();
            } else {
                window.webkit.messageHandlers.calendarEditSuccess.postMessage(string);
            }
        } else if (name == 'startTrainSuccess') {
            if (isAndroid) {
                android.startTrainSuccess();
            } else {
                window.webkit.messageHandlers.startTrainSuccess.postMessage(string);
            }
        } else if (name == 'actionEditSuccess') {
            if (isAndroid) {
                android.actionEditSuccess(params.updateTime);
            } else {
                window.webkit.messageHandlers.actionEditSuccess.postMessage(string);
            }
        } else if (name == 'addChallengeSuccess') {
            if (isAndroid) {
                android.addChallengeSuccess();
            } else {
                window.webkit.messageHandlers.addChallengeSuccess.postMessage(string);
            }
        } else if (name == 'updateActiveTarget') {
            if (isAndroid) {
                android.updateActiveTarget(params.userTargetStep, params.userTargetCalorie, params.userTargetSportStrength);
            } else {
                window.webkit.messageHandlers.updateActiveTarget.postMessage(string);
            }
        } else if (name == 'updateSportAI') {
            if (isAndroid) {
                android.updateSportAI();
            } else {
                window.webkit.messageHandlers.updateSportAI.postMessage(string);
            }
        } else if (name == 'updateDeepSeek') {
            if (isAndroid) {
                android.updateDeepSeek();
            } else {
                window.webkit.messageHandlers.updateDeepSeek.postMessage(string);
            }
        } else if (name == 'setUserWater') {
            if (isAndroid) {
                android.setWater(params.waterTarget, params.userWaterCount, params.isRemind, params.startWaterTime, params.endWaterTime, params.remindFreq);
            } else {
                window.webkit.messageHandlers.setWater.postMessage(string);
            }
        }
    }

    //生成callbackId
    static genCallbackId() {
        return `Webview_callback_${callbackId++}`
    }

    //添加callback
    static add(callbackId, callback) {
        callbackMap[callbackId] = {
            callback: callback
        }
    }

};

//注入全局方法，用于Native向h5回调
window.bridgeCallback = function (callbackId, res) {
    let cb = callbackMap[callbackId];
    let callback = cb["callback"];
    if (callback) {
        callback(res);
    }
    delete callbackMap.callbackId
}



// WEBPACK FOOTER //
// ./src/utils/JSBridge1.js